import React from 'react';
import type { monaco } from 'react-monaco-editor';
import { EditorProps } from '../EditorV3';

interface UseEditorCommandsProps {
  monacoInstance?: typeof monaco;
  editor?: monaco.editor.IStandaloneCodeEditor;
  commands: EditorProps['commands'];
}

const useEditorCommands = ({ monacoInstance, editor, commands }: UseEditorCommandsProps) => {
  React.useEffect(() => {
    if (!monacoInstance || !editor) {
      return;
    }

    const { KeyCode, KeyMod } = monacoInstance;
    const evaluatedCommands = commands({ KeyMod, KeyCode });

    evaluatedCommands.forEach(command => editor.addCommand(command.keyBindings, command.handler));
  }, [monacoInstance, editor, commands]);
};

export default useEditorCommands;
